import React from 'react';
import { Typography, Tooltip } from 'src/components/PulseUI';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

interface ControlLabelProps {
  label: string;
  children: React.ReactNode;
  hasTooltip?: boolean;
  required?: boolean;
  tooltipText?: string;
  showLabel?: boolean;
}

const ControlLabel: React.FC<ControlLabelProps> = ({
  showLabel = true,
  label,
  children,
  hasTooltip,
  required,
  tooltipText,
}) => {
  return (
    <div className="w-full">
      <div
        className={`${showLabel ? 'flex' : 'hidden'} items-center gap-2 mb-1`}
      >
        <Typography
          variant="body2"
          bold
          className="flex items-center gap-2 text-gray-700"
        >
          {label || ''}
          {hasTooltip && (
            <Tooltip
              content={
                tooltipText || 'This field is required to complete the form'
              }
              position="bottom"
            >
              <Icon
                icon={faInfoCircle}
                className="text-gray-500 cursor-pointer"
                aria-hidden="true"
              />
            </Tooltip>
          )}
        </Typography>
        {required && showLabel && (
          <Typography variant="caption" bold className="text-gray-500">
            (required)
          </Typography>
        )}
      </div>
      {children}
    </div>
  );
};

export default ControlLabel;
